import {getEnv} from '../../common/env/env';
import {ItemSetDto} from '../../common/shared/api/gateway/ItemSetDto.interface';
import {LandingPageVo} from '../../common/shared/api/karina/vo/page/LandingPageVo.interface';
import {getKageUrl} from '../../common/shared/utils/getKageUrl';
import {
  ContentsType,
  Maybe,
  MetaInfoType,
  SetPosterViewLandingList,
  User,
} from '../generated/types';
import {createPosterViewItem} from './PosterViewItem';

export function createSetPosterViewLandingList(
  userInfo: Maybe<User>,
  landingPage: LandingPageVo<ItemSetDto>,
  id: string,
  page: number
): SetPosterViewLandingList {
  return {
    id,
    isEnd: landingPage.is_end,
    totalCount: landingPage.total_count,
    type: ContentsType.Set,
    list: landingPage.list.map(item =>
      createPosterViewItem(userInfo, {
        itemSetDto: item,
        metaInfoType: MetaInfoType.CategoryAndAuthor,
      })
    ),
    title: landingPage.title,
    topImage: landingPage.top_image
      ? getKageUrl({
          kageId: landingPage.top_image,
          kageUrlPrefix: getEnv().kageUrlPrefix,
          resolution: 'o1',
        })
      : undefined,
    page,
  };
}
